import React from "react";
import { Routes, Route } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { COMPANY_INFO } from "./data";

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white text-slate-800 antialiased font-sans">
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Sticky Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ydelser" element={<Services />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/galleri" element={<Gallery />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          {/* Fallback route */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      {/* Floating Side Widgets */}
      <div className="fixed right-0 top-1/2 -translate-y-1/2 z-50 flex flex-col space-y-1">
        {COMPANY_INFO.phone && (
          <a
            href={`tel:${COMPANY_INFO.phone.replace(/\s+/g, "")}`}
            className="bg-sky-500 p-3 text-white rounded-l-md hover:bg-sky-600 transition-colors shadow-lg flex items-center justify-center group"
            title="Ring til os"
          >
            <Phone className="w-5 h-5" />
          </a>
        )}
        {COMPANY_INFO.email && (
          <a
            href={`mailto:${COMPANY_INFO.email}`}
            className="bg-sky-500 p-3 text-white rounded-l-md hover:bg-sky-600 transition-colors shadow-lg flex items-center justify-center group"
            title="Send os en e-mail"
          >
            <Mail className="w-5 h-5" />
          </a>
        )}
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
